<template>
    <div>
        <v-rating
            v-if    = "value && value.stars > 0"
            length  = "3"
            size    = "12"
            v-model = "rating"
            style   = "margin-top: -2px;"
            :color  = "color"
            dense
            readonly
        />
        <div
            v-if = "value && value.stars === 0"
            :class="value.id === 7 ? 'warning--text' : 'error--text'"
        >
            {{ value.name }}
        </div>
    </div>
</template>

<script>
export default {
    name: "CSiteTzbRating",

    props: {
        value: {
            required: false,
        },
        color: {
            required: false,
            default : function () {
                return "primary";
            }
        },
    },


    data: () => ({
    }),

    mounted() {
    },

    computed: {
        rating () {
            return this.value.stars;
        }
    }
}
</script>

<style scoped>

</style>